const ipcode = {
  "A": ".xyz",
  "B": ".ren",
  "C": ".fun",
  "D": ".net",
  "E": ".com",
  "F": ".cn",
  "G": ".cc",
  "H": ".c",
  "I": ".top",
  "J": ".art",
  "K": "",
  "L": "",
  "M": "",
  "N": "",
  "O": "",
  "P": "",
  "Q": "",
  "R": "",
}
const ipZero = {
  "!": "0",
  "#": "00",
  "$": "000",
  "%": "0000",
  "&": "00000",
}
let postfix = '';
let prefix = '';

function decoder(str, scale, flage = false) {
  //   const scale = '0123456789abcdefghijklmnopqrstuvwxyz';
  const scaleLen = scale.length;
  let ip = 0;
  let base = 1;

  // code -> int value
  for (const i of str) {
    const v = scale.indexOf(i);
    ip += v * base;
    base *= scaleLen;
  }
  if (flage) {
    return prefix + ip + postfix;
  }

  let result = '';
  while (ip > 0) {
    const left = ip % 256;
    ip = Math.floor((ip / 256), 10);
    result += left + '.';
  }
  return result.replace(/\.$/, '');
}

export function getIp(code) {
  postfix = '';
  prefix = '';
  let scale = '';
  if (code.indexOf('.') > 0) {
    return code;
  }
  if (code[code.length - 1] > 'A' && code[code.length - 1] < 'Z') {
    postfix = ipcode[code[code.length - 1]];
    if (ipZero[code[0]]) {
      prefix = ipZero[code[0]];
      code = code.slice(1, code.length)
    }
    code = code.slice(0, code.length - 1)
    scale = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    return decoder(code, scale, true);
  }
  scale = '0123456789abcdefghijklmnopqrstuvwxyz';
  return decoder(code, scale);
}



// WEBPACK FOOTER //
// ./src/utils/ipcoder.js